@import '~style-sheet-helpers/core.less';

.transparency-modal {
  width: 600px;
}

.transparency-modal-body {
  padding: 15px;
}

.transparency-content {
  display: flex;
  flex-direction: column;
}

.learn-more {
  margin-bottom: 10px;
}

.learn-more-link {
  color: var(--blue-500);
  text-decoration: underline;
}

.scan-container {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 20px;
}

.scan-input-container {
  position: relative;
  margin-top: 10px;
  margin-bottom: 5px;
}

.scan-input {
  width: 100%;
}

.scanner-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--grey-500);
}

.input-container {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.codes-input {
  width: 100%;
  min-height: 120px;
  margin-top: 10px;
}

.validation-error {
  color: var(--red-500);
  margin-top: 5px;
}

.save-success {
  color: var(--green-500);
  margin-top: 5px;
}
